import { render, staticRenderFns } from "./philosophies-list.vue?vue&type=template&id=bac764be&"
import script from "./philosophies-list.vue?vue&type=script&lang=js&"
export * from "./philosophies-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports